import { get, post, del } from "./ApiBase";
import { API_ENDPOINTS } from "./ApiEndPoints";

export const MfaLoginAPI = (data) => post(API_ENDPOINTS.AUTH.MFA_LOGIN, data);

const authHeader = (token) => ({ Authorization: `Bearer ${token}` });

export const getMfaSetupAPI = (setupToken) =>
  get(API_ENDPOINTS.AUTH.MFA_SETUP_GET, {}, authHeader(setupToken));

export const enableMfaAPI = (data, setupToken) =>
  post(API_ENDPOINTS.AUTH.MFA_SETUP_POST, data, authHeader(setupToken));

export const disableMfaAPI = () => del(API_ENDPOINTS.AUTH.MFA_DISABLE);
